const fuseSettingsConfig = {
  layout: {
    style: 'layout1',
    config: {
      scroll: 'content',
      navbar: {
        display: true,
        folded: true,
        position: 'left'
      },
      toolbar: {
        display: true,
        style: 'fixed',
        position: 'below'
      },
      footer: {
        display: false,
        style: 'fixed',
        position: 'below'
      },
      leftSidePanel: {
        display: true
      },
      rightSidePanel: {
        display: true
      },
      mode: 'fullwidth'
    }
  },
  customScrollbars: true,
  theme: {
    main: 'default',
    navbar: 'mainThemeDark',
    toolbar: 'mainThemeLight',
    footer: 'mainThemeDark'
  }
}

// const anexsysConfig = {
//   layout: {
//     style: 'layout1',
//     config: {
//       scroll: 'content',
//       navbar: {
//         display: true,
//         folded: true,
//         position: 'left'
//       },
//       toolbar: {
//         display: true,
//         style: 'fixed',
//         position: 'below'
//       },
//       footer: {
//         display: false,
//         style: 'fixed',
//         position: 'below'
//       },
//       leftSidePanel: {
//         display: true
//       },
//       rightSidePanel: {
//         display: true
//       },
//       mode: 'fullwidth'
//     }
//   },
//   customScrollbars: true,
//   theme: {
//     main: 'anexsys',
//     navbar: 'anexsys',
//     toolbar: 'anexsys',
//     footer: 'mainThemeDark',
//     colours: require('./brandColours/anexsys.colours.json')
//   }
// }

const hobsConfig = {
  layout: {
    style: 'layout1',
    config: {
      scroll: 'content',
      navbar: {
        display: true,
        folded: true,
        position: 'left'
      },
      toolbar: {
        display: true,
        style: 'fixed',
        position: 'below'
      },
      footer: {
        display: false,
        style: 'fixed',
        position: 'below'
      },
      leftSidePanel: {
        display: true
      },
      rightSidePanel: {
        display: true
      },
      mode: 'fullwidth'
    }
  },
  customScrollbars: true,
  theme: {
    main: 'hobshare',
    navbar: 'hobshare',
    toolbar: 'hobshare',
    footer: 'mainThemeDark',
    colours: require('./brandColours/hobs.colours.json')
  }
}

const _BRAND = hobsConfig
export default (() => {
  return process.env.BRAND || _BRAND || fuseSettingsConfig
})()
